module.exports = __webpack_public_path__ + "img/alex6.72715a1e.png";